module.exports = __webpack_public_path__ + "static/2-58a8081da965a8794b66ff1c909a7ca2.jpg";